class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector(".js-localization-form__panel"),
    };

    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );

    this.querySelectorAll("#LanguageList select").forEach((item) => {
      item.addEventListener("change", this.onItemChange.bind(this));
    });

    this.accordion = this.querySelector(".js-localization-form__accordion");
    if (this.accordion) {
      this.accordion.addEventListener(
        "click",
        this.onAccordionClick.bind(this)
      );
      this.accordion.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ENTER") {
          this.onAccordionClick(event);
        }
      });
    }
  }

  onAccordionClick(event) {

    console.log("Accordion clicked", event);
    event.preventDefault();
    const accordionLists = document.querySelectorAll(
      ".js-localization-form__accordion--list"
    );
    accordionLists.forEach((accordionList) => {
      accordionList.classList.toggle("accordion--open");

    })
  
    // accordionList.classList.toggle("accordion--open");
    this.accordion.classList.toggle("accordion--open");
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  onItemChange(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (!event.relatedTarget == this.accordion) {
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      } 
  }
}

customElements.define("localization-form", LocalizationForm);
